import React from "react";
import Icon from "@amzn/awsui-components-react/polaris/icon";
import {getPageWindow} from "./paging";
import "./WindowPagination.css";

/** Pager showing page 1, a few page numbers from the current page on, dots on either side where pages are skipped, and prev/next arrows. */
export default function WindowPagination({currentPageIndex, pagesCount, openEnd = false, disabled = false, onChange, ariaLabels = {}}) {
    const windowPages = getPageWindow(currentPageIndex, pagesCount);
    const firstShown = windowPages[0];
    const lastShown = windowPages[windowPages.length - 1];
    const pages = firstShown > 1 ? [1, ...windowPages] : windowPages;
    const skippedBefore = firstShown > 2;
    const morePages = openEnd || lastShown < pagesCount;
    const previousDisabled = disabled || currentPageIndex <= 1;
    const nextDisabled = disabled || (!openEnd && currentPageIndex >= pagesCount);
    const pageLabel = ariaLabels.pageLabel ?? (page => `Page ${page}`);

    const goTo = page => {
        if (!disabled && page !== currentPageIndex && onChange) {
            onChange({detail: {currentPageIndex: page}});
        }
    };

    return (
        <ul className={disabled ? "windowPagination windowPaginationDisabled" : "windowPagination"}
            aria-label={ariaLabels.paginationLabel}>
            <li>
                <button type="button" className="windowPaginationArrow"
                        aria-label={ariaLabels.previousPageLabel ?? "Previous page"}
                        disabled={previousDisabled} onClick={() => goTo(currentPageIndex - 1)}>
                    <Icon name="angle-left" variant={previousDisabled ? "disabled" : "normal"} />
                </button>
            </li>
            {pages.map(page => {
                const isCurrent = page === currentPageIndex;
                return (
                    <React.Fragment key={page}>
                        {page === firstShown && skippedBefore &&
                            <li className="windowPaginationDots" aria-hidden="true">...</li>}
                        <li>
                            <button type="button"
                                    className={isCurrent ? "windowPaginationPage windowPaginationCurrent" : "windowPaginationPage"}
                                    aria-label={pageLabel(page)} aria-current={isCurrent || undefined}
                                    disabled={disabled} onClick={() => goTo(page)}>
                                {page}
                            </button>
                        </li>
                    </React.Fragment>
                );
            })}
            {morePages && <li className="windowPaginationDots" aria-hidden="true">...</li>}
            <li>
                <button type="button" className="windowPaginationArrow"
                        aria-label={ariaLabels.nextPageLabel ?? "Next page"}
                        disabled={nextDisabled} onClick={() => goTo(currentPageIndex + 1)}>
                    <Icon name="angle-right" variant={nextDisabled ? "disabled" : "normal"} />
                </button>
            </li>
        </ul>
    );
}
